<div class="content">
    <div class="text-container">
        <h1 i18n>Payment failed</h1>
        <mat-icon>sentiment_very_dissatisfied</mat-icon>
        <p i18n class="info-text">Your payment could not be processed at this time. Please try again.</p>
        <button i18n class="info-text" (click)="dialogRef.close();">Ok</button>
    </div>
</div>